import * as Yup from 'yup';
import { PatchedToolForAdminModel } from 'types/admin-tools/PatchedToolForAdminModel';
import { Option } from 'types/types';
import { ToolForAdminModelVersion } from 'types/admin-tools/ToolForAdminModelVersion';
import { ToolVerifierOption } from 'types/admin-tools/ToolVerifierOption';
import { FileModel, PCRModel } from 'services/EpdClient';
import { ToolType } from 'types/tools/ToolType';

export const toolHeadSchema = Yup.object<Partial<PatchedToolForAdminModel>>({
  toolType: Yup.string(),
  name: Yup.string()
    .required('Tool Name is required')
    .matches(
      /^[A-Za-zÀ-ÖØ-öø-ÿ0-9]+(?:[A-Za-zÀ-ÖØ-öø-ÿ0-9\s\-–]*[A-Za-zÀ-ÖØ-öø-ÿ0-9])?$/,
      'Tool Name cannot contain special characters like @, #, $, %, etc.'
    ),
  hasApiIntegration: Yup.mixed<boolean | null>().required('Please select an option in the API field'),
  fullyPreverifiedCompany: Yup.mixed<Option | null>().when('toolType', {
    is: ToolType.FULLY_PREVERIFIED_TOOL,
    then: (opt: Yup.MixedSchema<Option | null>) => opt.required('Company is required'),
  }),
  toolOwnerCompany: Yup.mixed<Option | null>().required('Tool Owner is required'),
  toolOwnerCountry: Yup.mixed<Option | null>().required('Tool Owner Country is required'),
  contactPersonName: Yup.string().required('Contact person is required'),
  contactPersonEmail: Yup.string().required('Contact person email is required').email('Please enter a valid email address'),
  website: Yup.string().notRequired().url('Please enter a valid website URL, including http:// or https://'),
  description: Yup.string().notRequired().max(500, 'Tool Description must be 500 characters or fewer'),
});

// #13920 Must be hidden for some reason...
export const IS_QUALITY_CHECK_VISIBLE = false;

export const toolVersionSchema = Yup.object<Partial<ToolForAdminModelVersion>>({
  name: Yup.string()
    .required('Tool Version Number (Tool Owner) is required')
    .matches(/^[\w-.]+$/, 'Tool Version Number (Tool Owner) must not contain special symbols'),
  verifierUser: Yup.mixed<ToolVerifierOption>().required('Tool Verifier is required'),
  verifierCompanyName: Yup.string().required('Tool Verifier Company is required'),
  verifierApprovalDate: Yup.mixed<string | null>().required('Tool Approval Date by Verifier is required'),
  adminApprovalDate: Yup.mixed<string | null>().required('Tool Approval Date by EPD International is required'),
  validityDate: Yup.mixed<string | null>().required('Validity Date is required'),
  pcr: Yup.mixed<PCRModel | null>().required('PCR is required'),
  qualityInterval: IS_QUALITY_CHECK_VISIBLE
    ? Yup.mixed<number | null>().required('Quality check interval is required')
    : Yup.mixed<number | null>(),
  files: Yup.array<FileModel>().min(3, 'At least 3 files are required'),
});
